module.exports = __webpack_public_path__ + "static/media/logo.d290d738.png";